module.exports = __webpack_public_path__ + "c12d0e0c794eb15b8f8e175e17544156.svg";